export const PromoMap = {
    CREATE_PROMO_START: 'CREATE_PROMO_START',
    CREATE_PROMO_SUCCESS: 'CREATE_PROMO_SUCCESS',
    CREATE_PROMO_ERROR: 'CREATE_PROMO_ERROR',

    GET_ALL_PROMO_START: 'GET_ALL_PROMO_START',
    GET_ALL_PROMO_SUCCESS: 'GET_ALL_PROMO_SUCCESS',
    GET_ALL_PROMO_ERROR: 'GET_ALL_PROMO_ERROR',

    UPDATE_PROMO_START: 'UPDATE_PROMO_START',
    UPDATE_PROMO_SUCCESS: 'UPDATE_PROMO_SUCCESS',
    UPDATE_PROMO_ERROR: 'UPDATE_PROMO_ERROR',

    DELETE_PROMO_START: 'DELETE_PROMO_START',
    DELETE_PROMO_SUCCESS: 'DELETE_PROMO_SUCCESS',
    DELETE_PROMO_ERROR: 'DELETE_PROMO_ERROR',

    SET_SELECTED_PROMO: 'SET_SELECTED_PROMO',

    SET_PROMO_BATCH_NUMBER: 'SET_PROMO_BATCH_NUMBER',
    SET_PROMO_SEARCH_CHANGE: 'SET_PROMO_SEARCH_CHANGE',
    REFRESH_PROMO_LIST: 'REFRESH_PROMO_LIST',

    // Promo Code Usage History Actions
    GET_PROMO_USAGE_START: 'GET_PROMO_USAGE_START',
    GET_PROMO_USAGE_SUCCESS: 'GET_PROMO_USAGE_SUCCESS',
    GET_PROMO_USAGE_ERROR: 'GET_PROMO_USAGE_ERROR',
}

export const PromoActions = {
    getAllPromoStart: (data) => ({ type: PromoMap.GET_ALL_PROMO_START, payload: data }),
    getAllPromoSuccess: (data) => ({ type: PromoMap.GET_ALL_PROMO_SUCCESS, payload: data }),
    getAllPromoError: () => ({ type: PromoMap.GET_ALL_PROMO_ERROR }),

    createPromoStart: () => ({ type: PromoMap.CREATE_PROMO_START }),
    createPromoSuccess: (data) => ({ type: PromoMap.CREATE_PROMO_SUCCESS, payload: data }),
    createPromoError: (errors) => ({ type: PromoMap.CREATE_PROMO_ERROR, payload: { errors } }),

    updatePromoStart: () => ({ type: PromoMap.UPDATE_PROMO_START }),
    updatePromoSuccess: (data) => ({ type: PromoMap.UPDATE_PROMO_SUCCESS, payload: data }),
    updatePromoError: (errors) => ({ type: PromoMap.UPDATE_PROMO_ERROR, payload: { errors } }),

    deletePromoStart: () => ({ type: PromoMap.DELETE_PROMO_START }),
    deletePromoSuccess: (data) => ({ type: PromoMap.DELETE_PROMO_SUCCESS, payload: data }),
    deletePromoError: (errors) => ({ type: PromoMap.DELETE_PROMO_ERROR, payload: { errors } }),

    setSelectedPromo: (data) => ({ type: PromoMap.SET_SELECTED_PROMO, payload: data }),

    setPromoBatchNumber: (data) => ({ type: PromoMap.SET_PROMO_BATCH_NUMBER, payload: data }),
    searchPromoTextChange: (data) => ({ type: PromoMap.SET_PROMO_SEARCH_CHANGE, payload: data }),
    refreshPromoList: () => ({ type: PromoMap.REFRESH_PROMO_LIST }),
}

// Promo Code Usage History Action Creators
export const PromoUsageActions = {
    getPromoUsageStart: () => ({ type: PromoMap.GET_PROMO_USAGE_START }),
    getPromoUsageSuccess: (payload) => ({ type: PromoMap.GET_PROMO_USAGE_SUCCESS, payload }),
    getPromoUsageError: () => ({ type: PromoMap.GET_PROMO_USAGE_ERROR }),
} 